import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { ReportList } from "./components/list";

export const ItemInventoryReport = () => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const Location = useLocation();

  return (
    <>
      <Routes>
        <Route
          path={`/`}
          element={<Navigate replace="/" to={`${Location.pathname}/list`} />}
        ></Route>
        <Route path={"list"} element={<ReportList />}></Route>
      </Routes>
    </>
  );
};

